import {
  Card,
  CardBody,
  CardFooter,
  Heading,
  HStack,
  Tag,
  TagLabel,
  Text,
  Stack,
  Box,
  useColorModeValue,
} from "@chakra-ui/react";
import { IJob } from "./Job";

interface ExperienceCardProps {
  job: IJob;
}

export const ExperienceCard = ({ job }: ExperienceCardProps): JSX.Element => {
  const cardBg = useColorModeValue("white", "gray.800");
  const mutedColor = useColorModeValue("gray.600", "gray.400");
  const accentBorder = "accent.400";
  const hoverShadow = useColorModeValue("lg", "dark-lg");

  return (
    <Card
      variant="outline"
      bg={cardBg}
      borderLeftWidth="4px"
      borderLeftColor={accentBorder}
      borderRadius="lg"
      overflow="hidden"
      transition="box-shadow 0.2s, transform 0.2s"
      _hover={{ boxShadow: hoverShadow }}
    >
      <CardBody pt={5} pb={3}>
        <Stack spacing={3}>
          <Box>
            <Text
              fontSize="xs"
              fontWeight="600"
              textTransform="uppercase"
              letterSpacing="wider"
              color="accent.400"
            >
              {job.dates}
            </Text>
            <Heading size="sm" mt={1} fontWeight="600">
              {job.title}
            </Heading>
            <Text fontSize="sm" color={mutedColor} fontWeight="500">
              {job.company}
            </Text>
          </Box>
          <Stack spacing={2}>
            {job.description.map((line, i) => (
              <Text key={i} fontSize="sm" color={mutedColor} lineHeight="1.6">
                {line}
              </Text>
            ))}
          </Stack>
        </Stack>
      </CardBody>
      <CardFooter pt={0} pb={4}>
        <HStack spacing={2} flexWrap="wrap" gap={1}>
          {job.technologies.map((tech) => (
            <Tag
              key={tech}
              size="sm"
              variant="subtle"
              colorScheme="teal"
              borderRadius="md"
              fontWeight="500"
            >
              <TagLabel>{tech}</TagLabel>
            </Tag>
          ))}
        </HStack>
      </CardFooter>
    </Card>
  );
};
